import axios from './_nestAxios'

export const obtenerxIdAsEdicion = id => axios.get(`/caja-movimientos/${id}`)

export const insertarEstandar = data => axios.post('/caja-movimientos', data)

export const actualizarxId = (id, data) => axios.put(`/caja-movimientos/${id}`, data)

export const actualizarxIdAsAnular = id => axios.put(`/caja-movimientos/${id}/anular`)

export const generarReportexIdAsTicket = id =>
  axios.get(`/caja-movimientos/${id}/reporte-ticket`, { responseType: 'blob' })
